module.exports = __webpack_public_path__ + "static/media/st_patrick_game_pop_up.fd9edd8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/st_patrick_game_pop_up.png
// module id = 702
// module chunks = 0